// Observes when the side cart changes - refactor
const quickCart = document.querySelector('.quick-cart');

if (quickCart) {

    const observer = new MutationObserver(() => {

        // Initilize complete the look swiper slider

        import(flu.chunks.swiper).then(function (_ref) {

            var Swiper = _ref.Swiper;

            completeTheLookSlider = new Swiper(".complete-the-look-slider", {
                slidesPerView: "auto",
                spaceBetween: 15,
                grabCursor: true,
            });

        });

    });

    observer.observe(quickCart, { subtree: true, childList: true });

}

import(flu.chunks.swiper).then(function (_ref) {

    var Swiper = _ref.Swiper;

    this.completeTheLookSlider = new Swiper(".complete-the-look-slider", {
        slidesPerView: "auto",
        spaceBetween: 15,
        grabCursor: true,
    });

});

// Collage hero mobile slider - HOMEPAGE
// const collageHeroMobileSlider = document.querySelector('.collage-hero-mobile__slider');

// if (collageHeroMobileSlider) {

//     import(flu.chunks.swiper).then(function (_ref) {

//         var Swiper = _ref.Swiper,
//             Autoplay = _ref.Autoplay;
//             EffectFade = _ref.EffectFade;

//         this.collageHeroMobileSlider = new Swiper(".collage-hero-mobile__slider", {
//             modules: [EffectFade, Autoplay],
//             loop: true,
//             autoplay: {
//                 delay: 2000,
//                 disableOnInteraction: false,
//             },
//             speed: 300,
//             effect: 'fade',
//             fadeEffect: {
//                 crossFade: true,
//             },
//         });

//     });

// }

// Collection Slider(s) - HOMEPAGE
const collectionSlider = document.querySelector('.collection-slider');

if (collectionSlider) {

    import(flu.chunks.swiper).then(function (_ref) {

        // var _this3 = this;

        var Swiper = _ref.Swiper,
        Navigation = _ref.Navigation;

        this.collectionSlider = new Swiper(".collection-slider", {
            modules: [Navigation],
            slidesPerView: "auto",
            spaceBetween: 5,
            loop: true,
            breakpoints: {
                767: {
                    slidesPerView: 3,
                    spaceBetween: 5,
                },
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

    });

}